import { api } from './client';
import type {
  AdminLogChunkDto,
  AdminLogFileDto,
  AdminLogLevel,
  AdminLogSearchPageDto,
} from './types';

export const adminLogsApi = {
  list: (signal?: AbortSignal) =>
    api.get<AdminLogFileDto[]>('/api/admin/logs', { signal }),

  getChunk: (fileName: string, before?: number | null, signal?: AbortSignal) => {
    const query = before === null || before === undefined ? '' : `?before=${before}`;
    return api.get<AdminLogChunkDto>(
      `/api/admin/logs/${encodeURIComponent(fileName)}/content${query}`,
      { signal },
    );
  },

  search: (
    fileName: string,
    query: string,
    level?: AdminLogLevel | null,
    before?: number | null,
    signal?: AbortSignal,
  ) => {
    const parameters = new URLSearchParams();
    if (query) parameters.set('q', query);
    if (level) parameters.set('level', level);
    if (before !== null && before !== undefined) parameters.set('before', String(before));
    return api.get<AdminLogSearchPageDto>(
      `/api/admin/logs/${encodeURIComponent(fileName)}/search?${parameters.toString()}`,
      { signal },
    );
  },

  downloadUrl: (fileName: string) =>
    `/api/admin/logs/${encodeURIComponent(fileName)}/download`,

  gatewayList: (gatewayId: string, signal?: AbortSignal) =>
    api.get<AdminLogFileDto[]>(`${gatewayFilesPath(gatewayId)}`, { signal }),

  getGatewayChunk: (
    gatewayId: string,
    fileName: string,
    before?: number | null,
    signal?: AbortSignal,
  ) => {
    const query = before === null || before === undefined ? '' : `?before=${before}`;
    return api.get<AdminLogChunkDto>(
      `${gatewayFilesPath(gatewayId)}/${encodeURIComponent(fileName)}/content${query}`,
      { signal },
    );
  },

  gatewaySearch: (
    gatewayId: string,
    fileName: string,
    query: string,
    level?: AdminLogLevel | null,
    before?: number | null,
    signal?: AbortSignal,
  ) => {
    const parameters = new URLSearchParams();
    if (query) parameters.set('q', query);
    if (level) parameters.set('level', level);
    if (before !== null && before !== undefined) parameters.set('before', String(before));
    return api.get<AdminLogSearchPageDto>(
      `${gatewayFilesPath(gatewayId)}/${encodeURIComponent(fileName)}/search?${parameters.toString()}`,
      { signal },
    );
  },

  gatewayDownloadUrl: (gatewayId: string, fileName: string) =>
    `${gatewayFilesPath(gatewayId)}/${encodeURIComponent(fileName)}/download`,
};

const gatewayFilesPath = (gatewayId: string) =>
  `/api/admin/logs/gateways/${encodeURIComponent(gatewayId)}/files`;
